import {Modal, notification} from "antd";
import {IUser} from "../../../api/User/User.types";
import UserApi from "../../../api/User/User.api";
import {TOAST_DURATION} from "../../../settings";
import React from "react";
import {ExclamationCircleOutlined} from "@ant-design/icons";

interface Props {
    onOk?: (userId: number) => void,
    user: IUser,
}

export default function openDeleteUserModal({onOk, user}: Props) {

    async function onConfirmDelete() {
        let res = await UserApi.deleteUser(user.id);
        if (res) {
            notification.success({
                message: 'Success!',
                description: <span>You have successfully deleted {res.email}</span>,
                duration: TOAST_DURATION,
            })
            if (onOk) {
                onOk(user.id);
            }
        } else {
            notification.error({
                message: 'Error deleting user',
                description: <span>User could not be deleted</span>,
                duration: TOAST_DURATION,
            })
        }
    }

    const title = (
        <div className='custom-ant-modal-title'>
            <ExclamationCircleOutlined/>
            <div>
                Delete {user.email}
            </div>
        </div>
    )

    return Modal.confirm({
        title: title,
        content: `All of their information will be deleted, including but not limited to, their NAICS, PSC, and Keywords profile, their Auth0 account, and all of their profile information. Are you sure you want to delete this user?`,
        okType: "danger",
        icon: null,
        onOk: onConfirmDelete,
        centered: true,
        okText: "I understand, delete"
    })
}